import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Redux
import {
  getTreatmentArch,
  getOpposingTreatmentArch,
  getTreatmentPlanRevision,
  getUpperOpposingTreatmentArch,
  getLowerOpposingTreatmentArch,
  getArchToTreatInitial,
} from '../../../redux/reducers/common/teeth_chart';
import {
  onTreatmentArchChange,
  onOpposingTreatmentArchChange,
  onArchToTreatInitialChange,
  onDE4TreatmentArchChange,
} from '../../../redux/actions/common/teeth_chart';

/**
 * Treatment arch selection
 * @component
 * @alias ArchSelection
 * @category BPP
 */
class ArchSelection4 extends Component {
  /**
   * Displays opposing arch selections
   * @function
   * @param {String} opposing_arch - Opposing arch
   * @return {JSX} JSX for opposing arch selections
   */
  displayOpposingArchSelections(arch, opposing_arch) {
    return (
      <div className="arch-to-treat__selection__step">
        <div>
          <input
            type="radio"
            value={`${opposing_arch.toLowerCase()}_untreated`}
            checked={this.props[`${this.props.treatment_arch.toLowerCase()}_opposing_treatment_arch`] === `${opposing_arch.toLowerCase()}_untreated`}
            onChange={this.props.onOpposingTreatmentArchChange}
            disabled={this.props.treatment_arch !== arch}
          />
          {opposing_arch} arch will be untreated
        </div>
        <div>
          <input
            type="radio"
            value={`${opposing_arch.toLowerCase()}_alternate`}
            checked={this.props[`${this.props.treatment_arch.toLowerCase()}_opposing_treatment_arch`] === `${opposing_arch.toLowerCase()}_alternate`}
            onChange={this.props.onOpposingTreatmentArchChange}
            disabled={this.props.treatment_arch !== arch}
          />
          {opposing_arch} arch will be treated with an alternate system
        </div>
      </div>
    );
  }

  displayArchToTreatInitialSelections() {
    return (
      <div className="arch-to-treat__selection__step">
        <div>
          <input
            type="checkbox"
            value="upper"
            checked={this.props.archToTreatInitial === 'upper'}
            disabled={this.props.archToTreatInitial === 'lower' || this.props.treatment_arch !== 'both'}
            onChange={this.props.onArchToTreatInitialChange}
          />
          Upper to be treated initially. Lower will be added in future
        </div>
        <div>
          <input
            type="checkbox"
            value="lower"
            checked={this.props.archToTreatInitial === 'lower'}
            disabled={this.props.archToTreatInitial === 'upper' || this.props.treatment_arch !== 'both'}
            onChange={this.props.onArchToTreatInitialChange}
          />
          Lower to be treated initially. Upper will be added in future
        </div>
      </div>
    );
  }

  /**
   * Displays arch selection
   * @function
   * @param {String} arch - Upper lower or both
   * @return {JSX} JSX for arch selection
   */
  displayArchSelection(arch) {
    const labels = {
      both: 'Both arches',
      upper: 'Upper arch',
      lower: 'Lower arch',
    };

    return (
      <div className="arch-to-treat__selection">
        <input
          type="radio"
          value={arch}
          checked={this.props.treatment_arch === arch}
          onChange={this.props.onTreatmentArchChange}
          disabled={this.props.arch_disabled}
        />
        {labels[arch]}
        {arch === 'both' ? this.displayArchToTreatInitialSelections() : this.displayOpposingArchSelections(arch, arch === 'upper' ? 'Lower' : 'Upper')}
      </div>
    );
  }

  /**
   * Displays DE arch selection
   * @function
   * @param {String} arch - Upper lower or both
   * @return {JSX} JSX for arch selection
   */
  displayDEArchSelection(arch) {
    const labels = {
      upper: 'Upper arch',
      lower: 'Lower arch',
    };
    let archDescription = '';
    if (this.props.txPlan) {
      if (arch === 'upper') archDescription = this.props.txPlan.de4_is_upper_smartwire_new ? 'Initial Smartwires' : 'Additional Smartwires';
      else if (arch === 'lower') archDescription = this.props.txPlan.de4_is_lower_smartwire_new ? 'Initial Smartwires' : 'Additional Smartwires';
    }

    return (
      <div className="arch-to-treat__selection">
        <input type="checkbox" value={arch} checked={[arch, 'both'].includes(this.props.treatment_arch)} onChange={this.props.onDE4TreatmentArchChange} />
        {labels[arch]}
        {archDescription && ` - ${archDescription}`}
      </div>
    );
  }

  render() {
    return (
      <div className="arch-to-treat teeth-container__row p-slim grey-text">
        <div className="bold-text">Arch to Treat:</div>
        {this.props.treatment_plan_revision.includes('DE') ? (
          <>
            {this.displayDEArchSelection('upper')}
            {this.displayDEArchSelection('lower')}
          </>
        ) : (
          <>
            {this.displayArchSelection('both')}
            {this.displayArchSelection('upper')}
            {this.displayArchSelection('lower')}
          </>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    treatment_arch: getTreatmentArch(state),
    opposing_treatment_arch: getOpposingTreatmentArch(state),
    upper_opposing_treatment_arch: getUpperOpposingTreatmentArch(state),
    lower_opposing_treatment_arch: getLowerOpposingTreatmentArch(state),
    treatment_plan_revision: getTreatmentPlanRevision(state),
    archToTreatInitial: getArchToTreatInitial(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onTreatmentArchChange: onTreatmentArchChange,
      onDE4TreatmentArchChange: onDE4TreatmentArchChange,
      onOpposingTreatmentArchChange: onOpposingTreatmentArchChange,
      onArchToTreatInitialChange: onArchToTreatInitialChange,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ArchSelection4);
